
import "../Challenges.css"
import React, { useState,useEffect,useCallback,useRef } from "react";
import api from "views/auth/Api";
import { FiFilePlus } from "react-icons/fi";
// import ChallengesAssign from "./ChallengesAssign";
import { MdOutlineSchool } from "react-icons/md";
import { MdOutlinePerson } from "react-icons/md";
import { AiOutlineTeam } from "react-icons/ai";
import { RiTeamLine } from "react-icons/ri";
import { jwtDecode } from "jwt-decode";
// import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import { GiCrownCoin } from "react-icons/gi";
import { BiReset } from "react-icons/bi";
import CustomDropdown from "../../../../components/Dropdown"
import { IoSearchSharp } from "react-icons/io5";
import Loader from "components/loader";


const ChallangesTr = () => {

      const [data , setData] = useState([]);
      const [assignData, setAssignData] = useState([]);
      const [current , setCurrent] = useState("All");
      const [subjects , setSubjects] = useState([]);
      const [grades , setGrades] = useState([]);
      const [subject , setSubject] = useState('');
      const [search , setSearch] = useState('');
      const [searchValue , setSearchValue] = useState('');
      const [grade , setGrade] = useState('');
      const [page, setPage] = useState(1);
      const [totalPages, setTotalPages] = useState(1);
      const [loading, setLoading] = useState(false);
      

      const subjectRef = useRef();
      const gradeRef = useRef();

      const token = localStorage.getItem('token');
      const decoded = jwtDecode(token);
      const role = decoded.role
      const limit = 20; 


      const getdrop = async()=>{
        await api.get(`${API_BASE_URL}challenges/dropdown`)
      .then(function (response) {
          const subjectNames = [...new Set(response.data?.map(item => item.subject))];
          setSubjects(subjectNames)
          const gradeNames = [...new Set(response.data?.map(item => item.grade))];
          const sorted = gradeNames.sort((a, b) => a - b);
          setGrades(sorted)
      }).catch(error => {
        console.log("handlesubmit error for blog get ", error)
      });
      }
      useEffect(()=>{ 
        getdrop();
      },[]);
    

    const getData = useCallback(async () => {
      setLoading(true);
      if(current === "All"){
      try {
        const res = await api.get(`${API_BASE_URL}challenges`, {
          params: { page, limit, search, subject, grade }
        });
        setLoading(false);
        setData(res.data.items);
        setTotalPages(res.data.totalPages);
      } catch (err) {
        console.error(err);
      }}
      else if(current ==="Assigned"){
               api.get(`${API_BASE_URL}assigned-challenge`, {
          params: { page, limit, search, subject, grade },
        }).then(function (response) {
                  setLoading(false);
                    setAssignData(response.data?.items)
                    setTotalPages(response.data?.totalPages);
              }).catch(error => {
                console.log("handlesubmit error for blog get ", error)
              });
      }
    }, [page, limit, search, subject, grade, current]);
    
      useEffect(() => {
      getData();
    }, [getData]); // now this is valid

    const allChallenges =() => {
        setCurrent("All");
        setPage(1);
        getData();
        setSubject('');
        setGrade('');
        setSearch('')
    }
    const assignedChallenges =() => {
    setCurrent("Assigned");
    setPage(1)
        setSubject('');
        setGrade('');
        setSearch('');
        setSearchValue('');
        }

const newSubject = (e)=>{
  setSubject(e);
  setPage(1);
}
const newGrade = (e)=>{
  setGrade(e);
  setPage(1);
}

  return (
    <div className="ChallangesTr">
        <div className="ChallangesTrHead">
    <div className="search-devs" >
          <div className="search-form">
            <div className="searchImg"></div>
            <input className="search-input" placeholder="Search here" 
                    type="text"
                    value={searchValue}
                    onChange={(e) => {
                      setSearchValue(e.target.value)}}
                      onKeyDown={(e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value)
      setPage(1);
      }}}/>
      <span className="newSearchIcon" onClick={() => {setSearch(searchValue);
        setPage(1);
      }}>
    <IoSearchSharp className="w-[25px] h-[25px]"/></span>
             </div>
      <div className="subjectChaDrop">
        <CustomDropdown options={subjects}
       selectedd={newSubject}
       ref={subjectRef}
       type="Subject"
        /></div>
        <div className="gradeChaDrop">
        <CustomDropdown options={grades}
       selectedd={newGrade}
       ref={gradeRef}
       type="Grade" 
        /></div>

      <div className="filterReq flex items-center" onClick={()=>{
        setSubject('');
        setGrade('');
        setSearch('');
        setSearchValue('');
        gradeRef.current.rest();
        subjectRef.current.rest();
        setPage(1);
      }}>
        <BiReset className="addImg"/>
        <span className="ml-[5px]">Reset</span>
      </div>
        </div>
         <div className="ChallangesTrNew">
          <div className="flex">
           <span className={current==="All" ? "trChActive" : "trChNoactive"} onClick={() => allChallenges()}>All Challenges</span>
          {role === "Teacher" ? <span className={current==="Assigned" ? "trChActive" : "trChNoactive"} onClick={() => assignedChallenges()}>Assigned Challenges</span> : null}
           </div>
           <Link to={"/admin/tr/challenges/add"}>
            <div className="newChallenge" 
            // onClick={() => setCreate(true)}
              >
            <FiFilePlus className="addImg"/>
            <span>New Challenge</span>
           </div>
           </Link>
           </div>
    </div>
      {/* <div className="OverviewTr"> */}
        <div className="left-challengeTr">
       <div className="ChallangesTr-cards">
      {loading ? <Loader loading={loading} /> :!data[0] & current === "All" & !loading || !assignData[0] & current === "Assigned" & !loading ?  <span>NO Challages Available</span> : null}
       {current === "All" ? data.map(challenge => <Link to={`/admin/tr/challenges/details/${challenge.id}`} >
            <div className= "challangesTrCard" >
              <div className="cardImg-ch" style={{backgroundImage:`url(${FILES_URL}${challenge.img?.url})`}}></div>
                <h4 className="h4Mrg1">{challenge.challengeTitle} </h4>
                <p className="cardInfoSub">{challenge.subject}</p>
                {/* <h4 className="h4Mrg1">{challenge.subject} </h4> */}
                {/* <div className="clockIconDev1">
                  <div className="clockIcon"></div>
                  <span>{challenge.dueDate.substring(0, 10)}</span>
                  </div> */}
                <div className="clockIconDev1">
                   {/* <div className="personIcon"></div>
                  <span>{challenge.teamSize} Students</span> */}
                  <MdOutlineSchool className="gradesIcon"/>
                   <span>{challenge.grade}</span>
                </div>
                <div className="clockIconDev1">
                <MdOutlinePerson className="gradesIcon"/>
                <span>{ challenge.teacher?.name} - {challenge.teacher?.school?.name}</span>
                </div>
                {/* <div class="progress-challange">
                <div class="challange-bar" ></div>
                 </div> */}
            </div> </Link>
        ):null}
        {current === "Assigned" ? assignData.map(challenge => <Link to={`/admin/tr/challenges/assigned/${challenge.id}`}>
            <div className="challangesTrCard" >
              <div className="cardImg-ch" style={{backgroundImage:`url(${FILES_URL}${challenge.challenge?.img?.url})`}}>
              </div>
                <h4 className="h4Mrg1">{challenge.challenge?.challengeTitle} </h4>
                <p className="cardInfoSub">{challenge.challenge?.subject}</p>
                
                <div className="clockIconDev1">
                  <div className="flex">
                  <div className="clockIcon"></div>
                  <span className="mt-[1px]">{challenge.dueDate.substring(0, 10)}</span>
                  </div>
                  <GiCrownCoin className="giCrownCoin ml-[60px]"/> <p className="ptsSpan">{challenge.points} Points</p>
                  </div>

                <div className="assignDetails">
                <div className="clockIconDev">
                  <MdOutlineSchool className="gradesIcon"/>
                   <span>Grade {challenge.challenge?.grade}</span>
                </div>

                <div className="clockIconDev">
                  <RiTeamLine className="classIcon"/>
                   <span>Class {challenge.class?.class}</span>
                </div>


                <div className="clockIconDev">
                  <AiOutlineTeam className="teamIcon"/>
                   <span>Team Size {challenge.teamSize}</span>
                </div>
                </div>

            </div> </Link>
        ) :null}
       </div>
        </div>
      {!data[0] & current === "All" || !assignData[0] & current === "Assigned"  ?  null :
       <div className="flex items-center justify-center mt-6 mb-4 gap-3 bottom-0 ">
        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
        >
          Previous
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={`min-w-[40px] px-3 py-2 rounded-lg ${
              page === i + 1
                ? "pagination-active"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </button>
      </div>}        </div>
  );
};

export default ChallangesTr;
